import { html } from 'lit';
import { MoveHorizontal } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-move-horizontal')
export class PdsIconMoveHorizontal extends PdsIcon {
  @state()
  icon = MoveHorizontal;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
